import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var mediaBlobUrlIdentifier = 'media-blob-url';
export var isMediaBlobUrl = function isMediaBlobUrl(url) {
  return url.indexOf("".concat(mediaBlobUrlIdentifier, "=true")) > -1;
};
var getNumberFromParams = function getNumberFromParams(params, name) {
  var value = params.get(name);
  return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
var getStringFromParams = function getStringFromParams(params, name) {
  var value = params.get(name);
  if (!value) {
    return;
  }
  return decodeURIComponent(value);
};
export var getAttrsFromUrl = function getAttrsFromUrl(blobUrl) {
  var url = new URL(blobUrl);
  var hash = url.hash.replace('#', '');
  var params = new URLSearchParams(hash);
  var id = params.get('id');
  var contextId = params.get('contextId');
  // check if we have the required params
  if (!id || !contextId) {
    return;
  }
  return {
    id: id,
    contextId: contextId,
    collection: getStringFromParams(params, 'collection'),
    alt: getStringFromParams(params, 'alt'),
    height: getNumberFromParams(params, 'height'),
    width: getNumberFromParams(params, 'width'),
    size: getNumberFromParams(params, 'size'),
    name: getStringFromParams(params, 'name'),
    mimeType: getStringFromParams(params, 'mimeType')
  };
};
export var objectToQueryString = function objectToQueryString(json) {
  return Object.keys(json).filter(function (attrName) {
    return typeof json[attrName] !== 'undefined' && json[attrName] !== null;
  }).map(function (key) {
    var value = json[key];
    if (typeof value === 'undefined' || value === null) {
      return;
    }
    return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value.toString()));
  }).join('&');
};
export var addFileAttrsToUrl = function addFileAttrsToUrl(url, fileAttrs) {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    return url;
  }
  var mediaIdentifierAttr = _defineProperty({}, mediaBlobUrlIdentifier, 'true');
  var mergedAttrs = _objectSpread(_objectSpread({}, mediaIdentifierAttr), fileAttrs);
  var queryAttrs = objectToQueryString(mergedAttrs);

  // we can't use '?' separator for blob url params
  return "".concat(url, "#").concat(queryAttrs);
};